<app-hierarhija-pozicija></app-hierarhija-pozicija>
<app-image-panel [formService]="itemView['dynamicFormService']"></app-image-panel>
<ng-container *ngIf="!entryTemplateDisabled">
    <app-entry-template-dropdown [hidden]="itemView.activeTab !== 0" label="Obrazac unosa:" (selectObrazacUpisa)="changeObrazacUpisaJedinice($event)"></app-entry-template-dropdown>
</ng-container>
<ntap-prime-common-itemview #itemView></ntap-prime-common-itemview>
<p>{{removeButtons(itemView.activeTab)}}</p>
<ng-container *ngIf="currentDosjeListViewState && itemView.activeTab === 0" ntapDynamicFormProvider>
    <ng-container ntapFilterViewProvider [viewName]="currentDosjeListViewName"
        [viewState]="currentDosjeListViewStateFilter">
        <ng-container ntapListViewProvider [viewName]="currentDosjeListViewName"
            [viewState]="currentDosjeListViewState">
            <ntap-dynamic [compId]="INIT_COMP_ID"></ntap-dynamic>
        </ng-container>
    </ng-container>
</ng-container>
<ng-container *ngIf="!!rokCuvanjaViewState && itemView.activeTab === 1" ntapDynamicFormProvider>
    <ng-container ntapItemViewProvider [viewName]="rokCuvanjaViewName" [viewState]="rokCuvanjaViewState">
        <ntap-dynamic id="rokCuvanjaComp" [compId]="ITEMVIEW_UI_COMPID"></ntap-dynamic>
    </ng-container>
</ng-container>
<app-fast-data-entry-container [hidden]="itemView.activeTab !== 0"></app-fast-data-entry-container>
